import React, { useEffect, useState } from "react"
import DailyView from "./DailyView"
import HourlyView from "./HourlyView"
import OnDemand from "./OnDemand"
import ScheduleFilters from "./ScheduleFilters"
import { ReactComponent as Slant } from "./images/slant_header.svg"
import { ReactComponent as JFilmWatermark } from "./images/watermark_jfilm--slice.svg"
import { ReactComponent as ShortsWatermark } from "./images/watermark_pittsburgh_shorts--slice.svg"
import { ReactComponent as ThreeRiversWatermark } from "./images/watermark_3rff--slice.svg"
import { ReactComponent as FilmPittWatermark } from "./images/watermark_film_pittsburgh--slice.svg"

const Schedule = (props) => {
  const { bucket, buckets, festival, path, title, defaultView } = props

  const [view, setView] = useState(defaultView || "ondemand")
  const [eventTrackList, setEventTrackList] = useState([])
  const [trackList, setTrackList] = useState([])
  const [genreList, setGenreList] = useState([])
  const [virtualGenreList, setVirtualGenreList] = useState([])
  const [venueList, setVenueList] = useState([])
  const [loadedEvents, setLoadedEvents] = useState([])
  const [screenings, setScreenings] = useState([])
  const [ticketing, setTicketing] = useState([])
  const [ordering, setOrdering] = useState([])

  const [filters, setFilters] = useState({
    date: null,
    track: "all",
    genre: "",
    venue: "",
  })

  useEffect(() => {
    fetch(`/calendar.json?festival=${festival}&schedule=true`)
      .then((response) => response.json())
      .then((data) => {
        setLoadedEvents(data.filter((event) => event.showDaily))
        const loadedOnDemandEvents = data.filter((event) => event.showOnDemand)

        let tracks = [...trackList]
        let globalTracks = [...trackList]
        let genres = [...genreList]
        let virtualGenres = [...virtualGenreList]
        let venues = [...venueList]
        let editedScreenings = [...screenings]

        data.forEach((event) => {
          genres = genres.concat(event.genres)
          tracks = tracks.concat(event.tracks)
          venues = venues.concat(event.venue)
        })

        loadedOnDemandEvents.forEach((event) => {
          virtualGenres = virtualGenres.concat(event.genres)

          event.tracks.forEach((track) => {
            globalTracks.push({ name: track })
          })

          editedScreenings.push(event)
        })

        const sortedUniqueTracks = [
          ...new Set(globalTracks.map((item) => item.name)),
        ].sort((a, b) => a.name - b.name)

        setTrackList(sortedUniqueTracks)

        editedScreenings = [
          ...new Map(
            editedScreenings.map((item) => [item["id"], item]),
          ).values(),
        ]

        setScreenings(editedScreenings)
        setVenueList([...new Set(venues)].sort())
        setGenreList([...new Set(genres)].sort())

        if (bucket) {
          fetch(`/events/screenings.json?bucket=${bucket}&festival=${festival}`)
            .then((response) => response.json())
            .then((data) => {
              virtualGenres = [...virtualGenres]
              tracks = [...tracks]

              const loadedScreenings = [...data.screenings]
              loadedScreenings.forEach((screening) => {
                let screeningGenres = screening.films
                  .map((f) => (f["document"] || {})["genres"])
                  .flat()
                  .filter(Boolean)

                let screeningTracks = screening.films
                  .map((f) => (f["document"] || {})["tracks"])
                  .flat()
                  .filter(Boolean)

                screeningGenres = [...new Set(screeningGenres)]
                screeningTracks = [...new Set(screeningTracks)]

                screening.tracks = screeningTracks
                virtualGenres = virtualGenres.concat(screeningGenres)
                tracks = tracks.concat(screeningTracks)
              })

              setVirtualGenreList([...new Set(virtualGenres)].sort())
              setTrackList([...new Set(tracks)].sort())
              let newScreenings = loadedScreenings.concat(editedScreenings)

              newScreenings = [
                ...new Map(
                  newScreenings.map((item) => [item.name, item]),
                ).values(),
              ]

              setScreenings(newScreenings)
            })

          fetch(`/ticketing.json`)
            .then((response) => response.json())
            .then((data) => {
              setTicketing(data)
            })

          fetch(`/events/ordered_tracks.json`)
            .then((response) => response.json())
            .then((data) => {
              setOrdering(data)
            })
        } else {
          setEventTrackList([...new Set(tracks)].sort())
        }
      })
      .catch((error) => console.error(error))
  }, [])

  return (
    <>
      <div className={`section-header ${festival}`}>
        <h1>Schedule</h1>

        <ScheduleFilters
          filters={filters}
          setFilters={setFilters}
          festival={festival}
          view={view}
          setView={setView}
          tracks={trackList}
          genres={genreList}
          virtualGenres={virtualGenreList}
          venues={venueList}
        />

        <div className='slant-backdrop'>
          <Slant />
        </div>

        <div className='section-header__watermark'>
          {festival === "jfilm" ? (
            <JFilmWatermark />
          ) : festival === "pittsburgh_shorts" ? (
            <ShortsWatermark />
          ) : festival === "three_rivers_film_festival" ? (
            <ThreeRiversWatermark />
          ) : (
            <FilmPittWatermark />
          )}
        </div>
      </div>

      <div className='schedule__inner'>
        {view === "hourly" ? (
          <HourlyView
            title={title}
            topFestival={festival}
            events={loadedEvents}
            trackList={eventTrackList}
            filters={filters}
            path={path}
            screenings={screenings}
            ticketing={ticketing}
            ordering={ordering}
          />
        ) : view === "daily" ? (
          <DailyView
            title={title}
            topFestival={festival}
            events={loadedEvents}
            trackList={eventTrackList}
            filters={filters}
            path={path}
            screenings={screenings}
            ticketing={ticketing}
            ordering={ordering}
          />
        ) : (
          <OnDemand
            title={title}
            topFestival={festival}
            buckets={buckets}
            trackList={trackList}
            filters={filters}
            screenings={screenings}
            ticketing={ticketing}
            ordering={ordering}
            path={path}
          />
        )}
      </div>
    </>
  )
}

export default Schedule
